/**
 * Single-slot callback so session-replay code outside the React tree can refresh pagehide / flush
 * attachment after shutdown. Only one registrant is supported: a second `register*` overwrites the
 * previous slot until its returned unregister runs. That matches today’s single `SessionReplayInitializer`
 * instance; if multiple mount concurrently, the last registration wins (call unregister on unmount).
 */
let syncFlushAttachment: (() => void) | undefined;

export function registerSessionReplayFlushAttachmentSync(fn: () => void): () => void {
	if (process.env.NODE_ENV !== 'production' && syncFlushAttachment !== undefined) {
		// eslint-disable-next-line no-console -- dev-only guard for accidental double registration
		console.warn(
			'[sessionReplayFlushSyncRegistry] Replacing existing flush-attachment registrant; ensure prior instance unregistered.',
		);
	}
	syncFlushAttachment = fn;
	return () => {
		syncFlushAttachment = undefined;
	};
}

export function runSessionReplayFlushAttachmentSync(): void {
	syncFlushAttachment?.();
}
